// extracted by mini-css-extract-plugin
export var defaultWrapper = "_nr-3";
export var downloadButton = "_nr-4";
export var fileContainer = "_nr-9 _nr-7";
export var fileContainerBase = "_nr-7";
export var fileContainerFixedHeight = "_nr-8 _nr-7";
export var fileInfo = "_nr-5";
export var fileInfoWidthRestricted = "_nr-6";
export var fileType = "_nr-1";
export var fileTypeName = "_nr-2";
export var image = "_nr-0";
export var link = "_nr-b";
export var overflowEllipsis = "_nr-a";